// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import instagramIcon from '../assets/instagramIcon.png';
import facebookIcon from '../assets/facebookIcon.png';

const offices = [
  {
    state: 'Kentucky',
    hq: true,
    address: '500 N English Station Rd, Ste 102',
    cityStateZip: 'Louisville, KY 40245',
    phone: '502-785-8455',
    tel: '5027858455',
  },
  {
    state: 'Oklahoma',
    address: '100 NE Fifth St., First Floor',
    cityStateZip: 'Oklahoma City, OK 73104',
    phone: '405-449-4003',
    tel: '4054494003',
  },
  {
    state: 'Nebraska',
    address: '233 South 13th St., Suite 1100',
    cityStateZip: 'Lincoln, NE 68508',
    phone: '402-368-4080',
    tel: '4023684080',
  },
  {
    state: 'Missouri',
    address: '12645 Olive Blvd, Second Floor',
    cityStateZip: 'St. Louis, MO 63141',
    phone: '314-356-2330',
    tel: '3143562330',
  },
  {
    state: 'Kansas',
    address: '12345 W 95th St., Second Floor',
    cityStateZip: 'Lenexa, KS 66215',
    phone: '913-358-9006',
    tel: '9133589006',
  },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">

        {/* Column 1: Sitemap */}
        <div className="footer-column">
          <h3>Site Map</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/affiliate">The Elevate Program</Link></li>
            <li><Link to="/services/residential-services">Residential Services</Link></li>
            <li><Link to="/services/commercial-services">Commercial Services</Link></li>
            <li><Link to="/services/solar">Solar Services</Link></li>
          </ul>
        </div>

        {/* Column 2: Office Locations */}
        <div className="footer-column footer-column--offices">
          <h3>Our Offices</h3>
          <div className="footer-offices-grid">
            {offices.map((office) => (
              <div key={office.state} className="footer-office">
                <div className="footer-office__state">
                  {office.state}
                  {office.hq && <span className="footer-office__hq">HQ</span>}
                </div>
                <p>{office.address}<br />{office.cityStateZip}</p>
                <a href={`tel:${office.tel}`}>{office.phone}</a>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Divider Line */}
      <div className="footer-divider"></div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p className="footer-left">
          © {new Date().getFullYear()} Affordable Roofing + Solar Solutions. All rights reserved.
        </p>
        <div className="footer-right">
          <p>Follow our Socials!</p>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/affordableroofingandsolar?fbclid=IwY2xjawJmDZpleHRuA2FlbQIxMAABHkP02CLYyaaqxjKfHxC4370GfrqbVmliYBxf1YonWw0J8S9OMvMfOyRpSoiQ_aem_hkRbJAs8O2nMXIEuz9L8qw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagramIcon} alt="Instagram" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61574695587451"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebookIcon} alt="Facebook" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
